// import RootStore from 'stores/RootStore';
import RootStore from "stores/RootStore";
import ServiceStore from "stores/ServiceStore";
import type { RouteType } from "types/RouteType";
import DepartmentProductionScheduleStore from "./DepartmentProductionScheduleStore";
// import IFCTrackerLeftHeaderCell from './IFCTracker.LeftHeaderCell';
// import IFCTrackerRightHeaderCell from './IFCTracker.RightHeaderCell';

// import { utils } from '@intrasync/utils';
// import { utils } from '@intrasync/utils';
// // import IFCTrackerIcon from '@mui/icons-material/GridOn';
// import { toJS } from 'mobx';
// import IFCTrackerStore from 'stores/IFCTrackerStore';
// import ServiceStore from 'stores/ServiceStore';

const departmentProductionScheduleRoute: RouteType[] = [
  {
    name: "Department Production Schedule",
    path: "/department-production-schedule",
    layout: "/app",
    viewportCard: {
      header: {
        title: "Department Production Schedule",
        component: () => import("./DepartmentProductionSchedule.Header"),
        enableToolbox: true,
        enableBackButton: true,
        enableRefreshButton: true,
      },
      body: {
        scheduleContainer: {
          namespace: "DepartmentProductionSchedule",
          storeName: "departmentProductionScheduleStore",
          dateKey: "scheduleDate",
          dateRangeKey: "dateRange",
          rowHeight: (rowIndex: { index: number }, rootStore) => {
            const departmentProductionScheduleStore =
              rootStore?.departmentProductionScheduleStore as DepartmentProductionScheduleStore;
            // console.log('rowIndex', rowIndex);
            // console.log('rootStore', rootStore);
            return departmentProductionScheduleStore.getRowHeight(
              rowIndex.index
            );
          },
          enableSaveLocation: true,
        },
        grayBackground: true

      },
    },
    group: "Scheduling",
    requiresAuth: true, // Assuming it requires authentication since it requires permission
    requiresPermission: false,
    defaultQueryParams: {
      startDate: new Date().toISOString().split("T")[0],
      endDate: (() => {
        const end = new Date();
        end.setDate(end.getDate() + 90);
        return end.toISOString().split("T")[0];
      })(),
    },
    dialogs: [
      {
        name: "productDetails",
        title: "Product Details",
        component: () =>
          import(
            "./DepartmentProductionScheduleDialogs/DepartmentProductionSchedule.ProductDetails"
          ),
        cancelButton: true,
        height: 500,
      },
      {
        name: "addProduct",
        title: "Work Order",
        component: () =>
          import(
            "./DepartmentProductionScheduleDialogs/DepartmentProductionSchedule.AddProduct"
          ),
        cancelButton: false, // The dialog has its own cancel button
        height: 600,
        fullWidth: true,
      },
      {
        name: "unscheduledItems",
        title: "Unscheduled Items",
        component: () =>
          import(
            "./DepartmentProductionScheduleDialogs/DepartmentProductionSchedule.UnscheduledItems"
          ),
        cancelButton: true,
        width: 700,
        height: 500,
      },
    ],
    // permissionPath: '/app/ifc-tracker', // Maintaining permission path for consistency
    // defaultQueryParams: {
    //   productType: `job-stats/panel-count/:jobNumber.jobsProductTypes`,
    // },
    projectRoute: true,
    channels: [
      "scheduling/production-schedules",
      "scheduling/sales-order-lines",
      "scheduling/sales-orders",
      "manufacturing/products",
      "manufacturing/forms",
      "scheduling/production-departments",
      "manufacturing/work-orders",
    ],
    enableAutoFind: false,
    onEnter: async ({
      rootStore,
      queryParams,
    }: {
      rootStore: RootStore;
      queryParams: { startDate?: string; endDate?: string };
    }) => {
      const productionSchedulesStore =
        rootStore.productionSchedulesStore as ServiceStore;
      const workOrdersStore = rootStore.workOrdersStore as ServiceStore;
      const salesOrderLinesStore =
        rootStore.salesOrderLinesStore as ServiceStore;
      const salesOrdersStore = rootStore.salesOrdersStore as ServiceStore;
      const productsStore = rootStore.productsStore as ServiceStore;
      const productionDepartmentsStore =
        rootStore.productionDepartmentsStore as ServiceStore;
      const formsStore = rootStore.formsStore as ServiceStore;

      // Get date range from query params
      const { startDate, endDate } = queryParams;

      // Load all necessary data in parallel
      const promises = [];

      // Load production schedules (primary data source) within date range
      if (productionSchedulesStore) {
        promises.push(
          productionSchedulesStore.find({
            query: {
              $limit: 500,
              status: { $ne: "cancelled" },
              scheduleDate: {
                $gte: startDate,
                $lte: endDate,
              },
              $sort: { scheduleDate: 1 },
            },
          })
        );
      }

      // Load work orders (standalone piece scheduling) within date range
      if (workOrdersStore) {
        promises.push(
          workOrdersStore.find({
            query: {
              $limit: 500,
              status: { $nin: ["completed", "rejected"] },
              scheduledDate: {
                $gte: startDate,
                $lte: endDate,
              },
              $sort: { scheduledDate: 1 },
            },
          })
        );
      }

      // Load sales order lines for traceability
      if (salesOrderLinesStore) {
        promises.push(
          salesOrderLinesStore.find({
            query: {
              $limit: 1000,
              status: { $nin: ["dropped"] },
            },
          })
        );
      }

      // Load sales orders for customer/job context
      if (salesOrdersStore) {
        promises.push(
          salesOrdersStore.find({
            query: {
              $limit: 500,
              status: { $nin: ["cancelled"] },
            },
          })
        );
      }

      // Load reference data for display names
      if (productionDepartmentsStore) {
        promises.push(
          productionDepartmentsStore.find({ query: { $limit: 100 } })
        );
      }

      if (formsStore) {
        promises.push(formsStore.find({ query: { $limit: 100 } }));
      }

      if (productsStore) {
        // Load all products (there are 1700+) to ensure scheduled items are found
        promises.push(productsStore.find({ query: { $limit: 2000 } }));
      }

      try {
        await Promise.all(promises);
      } catch (error) {
        console.error("Error loading schedule data:", error);
      }
    },
    // onEnter: async ({
    //   rootStore,
    //   params,
    // }: {
    //   rootStore: RootStore;
    //   params: RouteParamsType;
    // }) => {
    // const ifcTrackerStore = rootStore.ifcTrackerStore as IFCTrackerStore;
    // const jobStatsIfcStatusStore =
    //   rootStore.jobStatsIfcStatusStore as ServiceStore;
    // const { clearMultiSelectArray, multiSelectArray } = ifcTrackerStore;
    // const { get: getIfcStats } = jobStatsIfcStatusStore;
    // const { jobNumber } = toJS(params);
    // getIfcStats(jobNumber as number);
    // if (multiSelectArray && multiSelectArray.length > 0) {
    //   clearMultiSelectArray();
    // }
    //   const {
    //     ifcTrackerStore: { setStartDate, setEndDate },
    //     panelStore: { find: findPlantPanels },
    //   } = rootStore;
    //   const { jobNumber } = toJS(params);
    //   const { productType } = toJS(queryParams);

    //   let startDateTemp = `${utils.getYearFromDate(new Date())}-01-01`;
    //   let endDateTemp = `${utils.getYearFromDate(new Date())}-12-31`;

    //   const startCastingDateResponse = await findPlantPanels({
    //     query: {
    //       productType: productType,
    //       jobNumber: jobNumber,
    //       $limit: 1,
    //       $sort: { castingDate: 1 },
    //       castingDate: { $nin: ['1970-01-01'] },
    //     },
    //   });
    //   if (
    //     startCastingDateResponse &&
    //     startCastingDateResponse.data &&
    //     startCastingDateResponse.data.length
    //   ) {
    //     const smallCastingDateResponse = startCastingDateResponse.data[0];
    //     if (smallCastingDateResponse && smallCastingDateResponse.castingDate) {
    //       startDateTemp = smallCastingDateResponse.castingDate;
    //     }
    //   }
    //   setStartDate(startDateTemp);

    //   const endCastingResult = await findPlantPanels({
    //     query: {
    //       productType,
    //       jobNumber,
    //       $limit: 1,
    //       $sort: { castingDate: -1 },
    //       castingDate: { $nin: ['1970-01-01'] },
    //     },
    //   });
    //   if (
    //     endCastingResult &&
    //     endCastingResult.data &&
    //     endCastingResult.data.length
    //   ) {
    //     const largestCastingResult = endCastingResult.data[0];

    //     if (largestCastingResult && largestCastingResult.castingDate) {
    //       endDateTemp = largestCastingResult.castingDate;
    //     }
    //   }

    //   setEndDate(endDateTemp);
    // },
    // onParamsChange: async ({
    //   rootStore,
    //   params,
    //   queryParams,
    //   previousParams,
    //   previousQueryParams,
    // }) => {
    //   if (
    //     queryParams?.productType !== previousQueryParams.productType ||
    //     !utils.isSameJobNumber(params?.jobNumber, previousParams.jobNumber)
    //   ) {
    //     rootStore.routerStore.triggerEnterSideEffects();
    //   }
    // },
    // onExit: async ({ rootStore }) => {
    //   const {
    //     ifcTrackerStore: {
    //       clearMultiSelectArray,
    //       setScrollToColumn,
    //       setScrollToRow,
    //       setCurrentHighlightPanel,
    //     },
    //   } = rootStore;
    //   clearMultiSelectArray();
    //   setCurrentHighlightPanel({});
    //   setScrollToRow(0);
    //   setScrollToColumn(0);
    // },
  },
];

export default departmentProductionScheduleRoute;
